import { initializeApp } from 'firebase/app';
import { getAuth } from 'firebase/auth';
import { getAnalytics, logEvent } from 'firebase/analytics';

const firebaseConfig = {
  apiKey: 'AIzaSyCMx_o6ij6dnN-RXyFCrjmN14hxFixQrYI',
  authDomain: 'proshere-2f562.firebaseapp.com',
  projectId: 'proshere-2f562',
  storageBucket: 'proshere-2f562.firebasestorage.app',
  messagingSenderId: '503129425632',
  appId: '1:503129425632:web:6f2724cfd441cef0577285',
  measurementId: 'G-7F7QG76QMB',
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const analytics = getAnalytics(app);

// Track custom events
export function trackPageView(pagePath, pageTitle) {
  logEvent(analytics, 'page_view', {
    page_path: pagePath,
    page_title: pageTitle,
  });
}

export function trackAction(eventName, params = {}) {
  logEvent(analytics, eventName, params);
}
